import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appPlaceholder]'
})
export class PlaceholderDirective {
    /**
     * Costruttore per la direttiva Placeholder
     * @param viewContainerRef {ViewContainerRef} riferimento del contenitore nella vista
     */
    constructor(public viewContainerRef: ViewContainerRef) {}
}